<template>
  <div class="GlobalNavigation">
    <button
      class="GlobalNavigation-link home"
      :class="{'on': $route.path === '/'}"
      @click="onHome"/>
    <button
      class="GlobalNavigation-link album"
      :class="{'on': $route.path === '/album'}"
      @click="onAlbum"
      :disabled="!isLogin"/>
    <button
      class="GlobalNavigation-link download"
      :class="{'on': $route.path === '/download'}"
      @click="onDownLoad"
      :disabled="!isLogin"/>
    <button
      class="GlobalNavigation-link member"
      :class="{'on': $route.path === '/member'}"
      @click="onMember"
      :disabled="!isLogin"/>
  </div>
</template>

<script>
export default {
  name: 'GlobalNavigation',
  components: {
  },
  props: {
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      friendCampaignInfo: null,
    }
  },
  computed: {
  },
  methods: {
    onHome() {
      this.push('/')
    },
    onAlbum() {
      this.push('/album')
    },
    onDownLoad() {
      this.push('/download')
    },
    onMail() {
      this.push('/')
    },
    onMember() {
      this.push('/member')
    },
    push(path) {
      if (this.$route.path != path) {
        this.$router.push(path)
      }
    },
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.GlobalNavigation {
  border-top: 1px solid #58575733;
  z-index: 40;
  display: flex;
  position: fixed;
  width: 375px;
  bottom: 0;
  background-color: #FBFCFD;
  justify-content: center;
  align-items: center;
  height: 55px;
  &-link {
    width: 25%;
    height: 100%;
    background-size: 30px;
    background-position: center;
    cursor: pointer;
    outline: none;
    &.home {
      background-image: url(../assets/Png/nav/ic_home.png);
      &:active, &.on { background-image: url(../assets/Png/nav/ic_home_active.png); }
    }
    &.album {
      background-image: url(../assets/Png/nav/ic_album.png);
      &:active, &.on { background-image: url(../assets/Png/nav/ic_album_active.png); }
    }
    &.download {
      background-image: url(../assets/Png/nav/ic_dl.png);
      &:active, &.on { background-image: url(../assets/Png/nav/ic_dl_active.png); }
    }
    &.member {
      background-image: url(../assets/Png/nav/ic_member.png);
      &:active, &.on { background-image: url(../assets/Png/nav/ic_member_active.png); }
    }
    &:disabled {
      opacity: .35;
    }
  }
}
</style>

